import API from "../../../utils/api";

// Our AI categories/sub-categories with their current Shopify mapping.
export const getCategoryMappingsApi = async () => {
    const response = await API.get('shopify-category-mapping/mappings');
    return { response };
};

// The cached Shopify taxonomy category list (for the picker). Optional { search }.
export const getShopifyCategoriesApi = async (filters) => {
    const response = await API.get('shopify-category-mapping/shopify-categories', { params: filters });
    return { response };
};

// Persist the mappings: { mappings: [{ id, shopify_category_gid, shopify_category_full_name }] }.
export const saveCategoryMappingsApi = async (payload) => {
    const response = await API.post('shopify-category-mapping/mappings', payload);
    return { response };
};

// Refresh the local Shopify taxonomy cache from Shopify.
export const syncShopifyTaxonomyApi = async () => {
    const response = await API.post('shopify-category-mapping/sync-taxonomy', {});
    return { response };
};

// Ask Claude to suggest the best Shopify category per our category (with confidence + reason).
export const aiSuggestCategoryMappingApi = async () => {
    const response = await API.post('shopify-category-mapping/ai-suggest', {});
    return { response };
};
